import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import SectionLabel from '@/components/ui/SectionLabel'
import { useContent } from '@/hooks/useContent'
import { imageRedimensionnee } from '@/helpers/images'

export default function MissionSection() {
  const { motDuPasteur } = useContent()

  return (
    <section id="vision" className="py-16 px-4 bg-white">
      <div className="max-w-lg md:max-w-5xl mx-auto grid gap-14 lg:grid-cols-2 lg:gap-20">
        {/* Vision */}
        <div className="text-center lg:text-left">
          <SectionLabel>Notre vision</SectionLabel>
          <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy text-center lg:text-left mt-3 mb-8 md:mb-10">Notre vision</h2>
          <p className="font-serif text-2xl md:text-3xl font-medium text-cmp-navy leading-snug mt-5 mb-6 text-balance">
            « Bâtir à Dieu un peuple saint, un peuple qui adore. »
          </p>
          <Link
            to="/a-propos"
            className="mt-6 inline-flex items-center gap-1.5 text-cmp-blue font-semibold text-sm hover:gap-2.5 transition-all"
          >
            En savoir plus sur nous
            <ChevronRight size={14} />
          </Link>
        </div>

        {/* Mot du pasteur */}
        <div
          id="pasteur"
          className="text-center lg:text-left border-t border-gray-100 pt-14 lg:border-t-0 lg:pt-0 lg:border-l lg:border-gray-100 lg:pl-16"
        >
          <SectionLabel>Mot du pasteur</SectionLabel>

          <div className="mt-6 flex flex-col items-center lg:items-start gap-5">
            <img
              // 512 px de large au plus sur téléphone (×2 pour les écrans haute densité)
              src={imageRedimensionnee(motDuPasteur.photo, 1000)}
              alt=""
              loading="lazy"
              className="h-full w-lg lg:w-32 lg:h-32 shrink-0 rounded-2xl object-cover shadow-lg ring-4 ring-white bg-cmp-navy"
            />

            <p className="font-bold text-cmp-navy text-lg">
              {motDuPasteur.fonction}
              <span className="block font-normal text-gray-400 text-xs mt-0.5">{motDuPasteur.nom}</span>
            </p>

            {/* <blockquote className="relative bg-cmp-cream rounded-sm rounded-tl-sm p-6 text-cmp-ink text-sm leading-relaxed italic shadow-[0_2px_10px_rgba(15,31,92,0.06)] ring-1 ring-cmp-navy/6 text-left">
              <span className="absolute -top-3 left-3 text-4xl text-cmp-gold-light font-serif leading-none select-none" aria-hidden="true">
                «
              </span>
              Nous ouvrons nos portes à toute personne en quête de vérité et d'amour. Que vous soyez de
              passage ou chez nous pour la première fois, sachez que vous êtes attendu et que Dieu a une
              place pour vous ici.
            </blockquote> */}

            {/* <Link
              to="/a-propos#mot-du-pasteur"
              className="inline-flex items-center gap-1.5 text-cmp-blue font-semibold text-sm hover:gap-2.5 transition-all"
            >
              Lire le message complet
              <ChevronRight size={14} />
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  )
}
